"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scaleBetween;

// Scale between AKA normalize
function scaleBetween(value, newMin, newMax, oldMin, oldMax) {
  return (newMax - newMin) * (value - oldMin) / (oldMax - oldMin) + newMin;
}


//////////////////
// WEBPACK FOOTER
// ./~/react-scroll-parallax/cjs/utils/scaleBetween.js
// module id = 305
// module chunks = 0